if (!customElements.get('product-layout-o2')) {
  customElements.define(
    'product-layout-o2',
    class ProductLayoutO2 extends HTMLElement {
      connectedCallback() {
        this.header = this.querySelector('.product-o2__header');
        this.sticky = this.querySelector('.product-o2__sticky');
        if (!this.header || !this.sticky || !window.O2Breakpoints) return;

        this.tabletUp = window.O2Breakpoints.media('tabletUp');
        this.syncHeader = () => {
          const parent = this.tabletUp.matches ? this.sticky : this;
          if (this.header.parentElement !== parent) parent.prepend(this.header);
        };
        this.tabletUp.addEventListener('change', this.syncHeader);
        this.syncHeader();
      }

      disconnectedCallback() {
        this.tabletUp?.removeEventListener('change', this.syncHeader);
      }
    }
  );
}
